import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import StaticBackground from './components/StaticBackground/StaticBackground';
import HamburgerMenu from './components/Navigation/HamburgerMenu';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import './styles/pages.css';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <StaticBackground />
        <HamburgerMenu />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
